<template>
  <span 
    v-if="((!user.is_locked && canManageLock(currentUser, user).canLock) || (user.is_locked && canManageLock(currentUser, user).canUnlock))"
    class="px-2 view-action"
    @click="handleLockToggle"
    :disabled="isLoading"
  >
    <i :class="user.is_locked ? 'fa fa-lock' : 'fa fa-unlock'"></i>
    {{ user.is_locked ? 'Unlock' : 'Lock' }}
  </span>
</template>
<script>
import { defineComponent } from 'vue';
import { useAccountLock } from '../composables/useAccountLock'

export default defineComponent({
  name: 'LockUnlockButton',
  props: {
    user: {
      type: Object,
      required: true
    },
    currentUser: {
      type: Object,
      required: true
    },
  },

  setup(props, { emit }) {
    const { isLoading, toggleLock, canManageLock } = useAccountLock();

    const handleLockToggle = async () => {
      const success = await toggleLock(props.user, props.onRefresh, props.currentPage);
      if (success) {
        emit("success", props.user);
      }
    };

    return {
      isLoading,
      canManageLock,
      handleLockToggle
    };
  }
});
</script>